<div class="tab-description">
  Configure the behavior and appearance of the conversation feedback flow. Use toggles to enable or disable features,
  and color pickers to customize button colors.
</div>

<div class="cards-container">
  <!-- Navigation UI -->
  <div class="container-fluid p-0">
    <!-- Card Container -->
    <div class="navigation-config-card">
      <!-- Card Header with title and save buttons -->
      <div class="card-header d-flex ">
        <div class="card-title mb-0">Navigation Configuration</div>
        <div class="card-description mb-0">Set navigation behavior, including progress bar, auto-advance, and browser
          back support.</div>
        <!-- <div class="action-buttons">
        <button class="btn btn-outline-primary me-2" (click)="saveConfig(false)">
          <i class="fa fa-save me-1"></i> Save
        </button>
        <button class="btn btn-primary" (click)="saveConfig(true)">
          <i class="fa fa-upload me-1"></i> Save and Publish
        </button>
      </div> -->
      </div>

      <!-- Card Body with form -->
      <div class="card-body">
        <form>
          <!-- Progress Bar Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="conversation-progress-bar">
                  <!-- Enable conversation progress bar for customer feedback -->
                  Enable conversation progress bar
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="conversation-progress-bar"
                    [(ngModel)]="navigationConfig.isConversationProgressBar" 
                    (ngModelChange)="makeDirty('navigation')"
                    (change)="validateConversationProgressBar($event, navigationConfig.isConversationProgressBar)"
                    [disabled]="!isUserHasWriteAccess"
                    name="isConversationProgressBar">
                </div>
              </div>
            </div>
          </div>

          <!-- Progress Bar Color - Only visible when progress bar is enabled -->
          <div class="form-row mb-4" *ngIf="navigationConfig.isConversationProgressBar">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="progressbar-color">
                  <!-- Progressbar Color (click on the color block on right to change and select the required color) -->
                  Set Progressbar Color
                </label>
                <div class="color-picker-container">
                  <div class="color-value">{{navigationConfig.progressbarColor}}</div>
                  <input type="color" class="form-control form-control-color" id="progressbar-color"
                    [(ngModel)]="navigationConfig.progressbarColor" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!isUserHasWriteAccess"
                    name="progressbarColor">

                </div>
              </div>
            </div>
          </div>

          <!-- Button Position Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="button-below-interaction">
                  <!-- Move the Next, Back and Submit button below the questions -->
                  Place Next, Back, and Submit buttons below questions
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="button-below-interaction"
                    [(ngModel)]="navigationConfig.buttonBelowInteraction" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!isUserHasWriteAccess"
                    name="buttonBelowInteraction">
                </div>
              </div>
            </div>
          </div>

          <!-- Auto Move to Next Page Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto rated-text" for="auto-move-next-page">
                  <!-- Automatically move to Next page on completion of all question rating on a page -->
                  Auto-advance to next page when all questions are rated
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="auto-move-next-page"
                    [(ngModel)]="navigationConfig.autoMoveToNextPage" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!isUserHasWriteAccess"
                    name="autoMoveToNextPage">
                </div>
              </div>
            </div>
          </div>

          <!-- Enable Browser Back Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="enable-browser-back">
                  <!-- Enable your device's Browser Back button -->
                  Support browser Back button
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="enable-browser-back"
                    [(ngModel)]="navigationConfig.enableBrowserBack" 
                    (ngModelChange)="makeDirty('navigation')"
                    (change)="onEnableBrowserBack()"
                    [disabled]="!isUserHasWriteAccess"
                    name="enableBrowserBack">
                </div>
              </div>
            </div>
          </div>

         <!-- Enable Back Button Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="enable-back-button">
                  Enable Back button in feedback flow
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="enable-back-button"
                    [(ngModel)]="navigationConfig.enableBackButton" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!isUserHasWriteAccess"
                    name="enableBackButton">
                </div>
              </div>
            </div>
          </div>

          <!-- Next Button Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="next-button-color">
                  <!-- Next Button Color (click on the color block on right to change and select the required color) -->
                  Set Next button background color
                </label>
                <div class="color-picker-container">
                  <div class="color-value">{{navigationConfig.nextButtonColor}}</div>
                  <input type="color" class="form-control form-control-color" id="next-button-color"
                    [(ngModel)]="navigationConfig.nextButtonColor" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!isUserHasWriteAccess"
                    name="nextButtonColor">

                </div>
              </div>
            </div>
          </div>

          <!-- Next Button Text Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="next-button-text-color">
                  <!-- Next Button Text Color (click on the color block on right to change and select the required color) -->
                  Set Next button text color
                </label>
                <div class="color-picker-container">
                  <div class="color-value">{{navigationConfig.nextButtonTextColor}}</div>
                  <input type="color" class="form-control form-control-color" id="next-button-text-color"
                    [(ngModel)]="navigationConfig.nextButtonTextColor" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!isUserHasWriteAccess"
                    name="nextButtonTextColor">

                </div>
              </div>
            </div>
          </div>


          <!-- Back Button Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!navigationConfig.enableBackButton">
                <label class="control-label me-auto" for="back-button-color"
                  [class.text-muted]="!navigationConfig.enableBackButton">
                  <!-- Back Button Color (click on the color block on right to change and select the required color) -->
                  Set Back button background color
                </label>
                <div class="color-picker-container">
                  <div class="color-value" *ngIf="navigationConfig.enableBackButton">
                    {{navigationConfig.backButtonColor}}
                  </div>
                  <input type="color" class="form-control form-control-color" id="back-button-color"
                    [(ngModel)]="navigationConfig.backButtonColor" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!navigationConfig.enableBackButton || !isUserHasWriteAccess" name="backButtonColor">

                </div>
              </div>
            </div>
          </div>

          <!-- Back Button Text Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!navigationConfig.enableBackButton">
                <label class="control-label me-auto" for="back-button-text-color"
                  [class.text-muted]="!navigationConfig.enableBackButton">
                  <!-- Back Button Text Color (click on the color block on right to change and select the required color) -->
                  Set Back button text color
                </label>
                <div class="color-picker-container">
                  <div class="color-value" *ngIf="navigationConfig.enableBackButton">
                    {{navigationConfig.backButtonTextColor}}</div>
                  <input type="color" class="form-control form-control-color" id="back-button-text-color"
                    [(ngModel)]="navigationConfig.backButtonTextColor" 
                    (ngModelChange)="makeDirty('navigation')"
                    [disabled]="!navigationConfig.enableBackButton || !isUserHasWriteAccess" name="backButtonTextColor">

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- Card Footer with action buttons -->
      <div class="card-footer d-flex justify-content-end">
        <button class="footer-action-button custom-cancel-btn" [disabled]="!isUserHasWriteAccess" (click)="cancelConfig('navigation')">Cancel</button>
        <button class="footer-action-button custom-save-btn" [disabled]="!isNavigationConfigChanged || !isUserHasWriteAccess"
          (click)="saveConfig('navigation')">Save</button>
      </div>
    </div>
  </div>
  <!-- Header UI -->
  <div class="container-fluid p-0">
    <!-- Card Container -->
    <div class="header-config-card">
      <!-- Card Header with title and save buttons -->
      <div class="card-header d-flex  ">
        <div class="card-title mb-0">Header Configuration</div>
        <div class="card-description mb-0">Customize header content like title, subtitle, or branding.</div>
        <!-- <div class="action-buttons">
        <button class="btn btn-outline-primary me-2" (click)="saveConfig(false)">
          <i class="fa fa-save me-1"></i> Save
        </button>
        <button class="btn btn-primary" (click)="saveConfig(true)">
          <i class="fa fa-upload me-1"></i> Save and Publish
        </button>
      </div> -->
      </div>

      <!-- Card Body with form -->
      <div class="card-body">
        <form>
          <!-- Enable Header Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="show_header">Show header in customer conversation</label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="show_header" 
                    [(ngModel)]="headerConfig.enableHeader" (ngModelChange)="makeDirty('header')" (change)="onEnableHeader()" [disabled]="!isUserHasWriteAccess" name="enableHeader">
                </div>
              </div>
            </div>
          </div>

                    <!-- Header Text -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div [class.disabled]="!headerConfig.enableHeader">
                <label class="control-label mb-2" for="header_text" [class.text-muted]="!headerConfig.enableHeader">
                  Text
                </label>
                <input type="text" class="form-control" id="header_text" placeholder="Enter header text"
                  [(ngModel)]="headerConfig.headerTitle" 
                  (ngModelChange)="makeDirty('header')"
                  [disabled]="!headerConfig.enableHeader || !isUserHasWriteAccess" name="headerTitle">
              </div>
            </div>
          </div>

          <!-- Header Background Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!headerConfig.enableHeader">
                <label class="control-label me-auto" for="header_color" [class.text-muted]="!headerConfig.enableHeader">
                  Background Color
                </label>
                <div class="color-picker-container">
                  <div class="color-value" *ngIf="headerConfig.enableHeader">{{headerConfig.headerBackgroundColor}}
                  </div>
                  <input type="color" class="form-control form-control-color" id="header_color"
                    [(ngModel)]="headerConfig.headerBackgroundColor" 
                    (ngModelChange)="makeDirty('header')"
                    [disabled]="!headerConfig.enableHeader || !isUserHasWriteAccess" name="headerBackgroundColor">

                </div>
              </div>
            </div>
          </div>


          <!-- Header Text Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!headerConfig.enableHeader">
                <label class="control-label me-auto" for="header_text_color"
                  [class.text-muted]="!headerConfig.enableHeader">
                  Text Color
                </label>
                <div class="color-picker-container">
                  <div class="color-value" *ngIf="headerConfig.enableHeader">{{headerConfig.headerTextColor}}</div>
                  <input type="color" class="form-control form-control-color" id="header_text_color"
                    [(ngModel)]="headerConfig.headerTextColor" 
                    (ngModelChange)="makeDirty('header')"
                    [disabled]="!headerConfig.enableHeader || !isUserHasWriteAccess" name="headerTextColor">

                </div>
              </div>
            </div>
          </div>

          <!-- Enable Logo Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!headerConfig.enableHeader">
                <label class="control-label me-auto" for="show_brand_logo"
                  [class.text-muted]="!headerConfig.enableHeader">
                  Enable logo
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="show_brand_logo"
                    [(ngModel)]="headerConfig.enableHeaderLogo" 
                    (ngModelChange)="makeDirty('header')"
                    [disabled]="!headerConfig.enableHeader || !isUserHasWriteAccess" name="enableHeaderLogo">
                </div>
              </div>
            </div>
          </div>

          <!-- Logo Upload -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div [class.disabled]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo">
                <label class="control-label mb-2" for="header_logo"
                  [class.text-muted]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo">
                  Brand Logo
                </label>

                <div class="file-upload-container d-flex align-items-center">
                  <div class="file-name-display me-3 flex-grow-1">
                    <span *ngIf="uploadHeaderImageName">{{uploadHeaderImageName}}</span>
                    <span *ngIf="!uploadHeaderImageName" class="text-muted">Logo Size 23x23 pixels</span>
                    <button *ngIf="uploadHeaderImageName" class="btn-close ms-2" [disabled]="!isUserHasWriteAccess" (click)="clearFileInput(headerfileInput,'header')"
                      title="Remove file">
                    </button>
                  </div>

                  <div class="upload-button">
                    <button class="upload-btn"
                      [disabled]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo || !isUserHasWriteAccess"
                      (click)="headerfileInput.click()">
                      Select a file
                    </button>
                    <input #headerfileInput id="headerfileInput" type="file" class="d-none" (change)="onFileSelect($event,'header')"
                      accept="image/*">
                  </div>
                </div>

                <div class="logo-preview mt-2" *ngIf="headerConfig.headerLogoUrl">
                  <a [href]="'https:'+headerLogoDetail.url" target="_blank" class="logo-url">
                    {{headerLogoDetail.filename}}
                  </a>
                  <button class=" ms-2" [disabled]="!isUserHasWriteAccess" (click)="removeImage('header','remove')" title="Remove logo">
                    <img src="./assets/images/trash-can-outline.svg">
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Logo Position -->
          <div class="form-row">
            <div class="form-group col-12">
              <div [class.disabled]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="control-label me-3 mb-0"
                    [class.text-muted]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo">
                    Logo Position
                  </label>
                  <div class="radio-group d-flex align-items-center">
                    <div class="form-check form-check-inline me-4">
                      <input class="form-check-input" type="radio" id="header_position_left"
                        [(ngModel)]="headerConfig.headerPosition" value="left"
                        (ngModelChange)="makeDirty('header')"
                        [disabled]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo || !isUserHasWriteAccess" name="headerPosition">
                      <label class="form-check-label" for="header_position_left">Left</label>
                    </div>
                    <div class="form-check form-check-inline me-4">
                      <input class="form-check-input" type="radio" id="header_position_center"
                        [(ngModel)]="headerConfig.headerPosition" value="center"
                        (ngModelChange)="makeDirty('header')"
                        [disabled]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo || !isUserHasWriteAccess" name="headerPosition">
                      <label class="form-check-label" for="header_position_center">Center</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="header_position_right"
                        [(ngModel)]="headerConfig.headerPosition" value="right"
                        (ngModelChange)="makeDirty('header')"
                        [disabled]="!headerConfig.enableHeader || !headerConfig.enableHeaderLogo || !isUserHasWriteAccess" name="headerPosition">
                      <label class="form-check-label" for="header_position_right">Right</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- Card Footer with action buttons -->
      <div class="card-footer d-flex justify-content-end">
        <button class="footer-action-button custom-cancel-btn" [disabled]="!isUserHasWriteAccess" (click)="cancelConfig('header')">Cancel</button>
        <button class="footer-action-button custom-save-btn" [disabled]="!isHeaderConfigChanged || !isUserHasWriteAccess"
          (click)="saveConfig('header')">Save</button>
      </div>
    </div>
  </div>
  <!-- Footer UI -->
  <div class="container-fluid p-0">
    <!-- Card Container -->
    <div class="footer-config-card">
      <!-- Card Header with title and save buttons -->
      <div class="card-header d-flex ">
        <div class="card-title mb-0">Footer Configuration</div>
        <div class="card-description mb-0">Control button placement and style with color and text customization.</div>
        <!-- <div class="action-buttons">
        <button class="btn btn-outline-primary me-2" (click)="saveConfig(false)">
          <i class="fa fa-save me-1"></i> Save
        </button>
        <button class="btn btn-primary" (click)="saveConfig(true)">
          <i class="fa fa-upload me-1"></i> Save and Publish
        </button>
      </div> -->
      </div>

      <!-- Card Body with form -->
      <div class="card-body">
        <form>
          <!-- Enable Footer Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center">
                <label class="control-label me-auto" for="show_footer">Show footer in customer conversation</label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="show_footer" 
                    [(ngModel)]="footerConfig.enableFooter" (ngModelChange)="makeDirty('footer')" [disabled]="!isUserHasWriteAccess" name="enableFooter">
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Background Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!footerConfig.enableFooter">
                <label class="control-label me-auto" for="footer_color" [class.text-muted]="!footerConfig.enableFooter">
                  <!-- Footer Background Color (click on the color block on right to change and select the required color) -->
                  Background Color
                </label>
                <div class="color-picker-container">
                  <div class="color-value" *ngIf="footerConfig.enableFooter">{{footerConfig.footerBackgroundColor}}
                  </div>
                  <input type="color" class="form-control form-control-color" id="footer_color"
                    [(ngModel)]="footerConfig.footerBackgroundColor" 
                    (ngModelChange)="makeDirty('footer')"
                    [disabled]="!footerConfig.enableFooter || !isUserHasWriteAccess" name="footerBackgroundColor">

                </div>
              </div>
            </div>
          </div>

          <!-- Footer Text Color -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!footerConfig.enableFooter">
                <label class="control-label me-auto" for="footer_text_color"
                  [class.text-muted]="!footerConfig.enableFooter">
                  <!-- Footer Text Color (click on the color block on right to change and select the required color) -->
                  Text Color
                </label>
                <div class="color-picker-container">
                  <div class="color-value" *ngIf="footerConfig.enableFooter">{{footerConfig.footerTextColor}}</div>
                  <input type="color" class="form-control form-control-color" 
                    id="footer_text_color" [(ngModel)]="footerConfig.footerTextColor"
                    (ngModelChange)="makeDirty('footer')"
                    [disabled]="!footerConfig.enableFooter || !isUserHasWriteAccess" name="footerTextColor">

                </div>
              </div>
            </div>
          </div>

          <!-- Enable Logo Toggle -->
          <div class="form-row mb-4">
            <div class="form-group col-12">
              <div class="d-flex align-items-center" [class.disabled]="!footerConfig.enableFooter">
                <label class="control-label me-auto" for="show_brand_logo_footer"
                  [class.text-muted]="!footerConfig.enableFooter">
                  <!-- Show your Brand logo in the conversation Footer (if different from Header) -->
                  Enable logo
                </label>
                <div class="form-switch">
                  <input class="form-check-input" type="checkbox" id="show_brand_logo_footer"
                    [(ngModel)]="footerConfig.showLogoInFooter" 
                    (ngModelChange)="makeDirty('footer')"
                    [disabled]="!footerConfig.enableFooter || !isUserHasWriteAccess" name="showLogoInFooter">
                </div>
              </div>
            </div>
          </div>

          <!-- Logo Upload -->
          <div class="form-row">
            <div class="form-group col-12">
              <div [class.disabled]="!footerConfig.enableFooter || !footerConfig.showLogoInFooter">
                <label class="control-label mb-2" for="footer_logo"
                  [class.text-muted]="!footerConfig.enableFooter || !footerConfig.showLogoInFooter">
                  <!-- Footer Logo (if different from Header) -->
                   Brand Logo
                </label>

                <div class="file-upload-container d-flex align-items-center">
                  <div class="file-name-display me-3 flex-grow-1">
                    <span *ngIf="uploadFooterImageName">{{uploadFooterImageName}}</span>
                    <span *ngIf="!uploadFooterImageName" class="text-muted">Logo Size 23x23 pixels</span>
                    <button *ngIf="uploadFooterImageName" class="btn-close ms-2" [disabled]="!isUserHasWriteAccess" (click)="clearFileInput(footerfileInput,'footer')"
                      title="Remove file">
                    </button>
                  </div>

                  <div class="upload-button">
                    <button class="upload-btn"
                      [disabled]="!footerConfig.enableFooter || !footerConfig.showLogoInFooter || !isUserHasWriteAccess"
                      (click)="footerfileInput.click()">
                      Select a file
                    </button>
                    <input #footerfileInput id="footerfileInput" type="file" class="d-none" (change)="onFileSelect($event,'footer')"
                      accept="image/*">
                  </div>
                </div>

                <div class="logo-preview mt-2" *ngIf="footerConfig.footerLogoUrl">
                  <a [href]="'https:'+footerLogoDetail.url" target="_blank" class="logo-url">
                    {{footerLogoDetail.filename}}
                  </a>
                  <button class="ms-2" [disabled]="!isUserHasWriteAccess" (click)="removeImage('footer','remove')" title="Remove logo">
                    <img src="./assets/images/trash-can-outline.svg">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- Card Footer with action buttons -->
      <div class="card-footer d-flex justify-content-end">
        <button class="footer-action-button custom-cancel-btn" [disabled]="!isUserHasWriteAccess" (click)="cancelConfig('footer')">Cancel</button>
        <button class="footer-action-button custom-save-btn" [disabled]="!isFooterConfigChanged || !isUserHasWriteAccess"
          (click)="saveConfig('footer')">Save</button>
      </div>
    </div>
  </div>
</div>